// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"Viewer3D_canvasContainer__3Jkt_"};